import React, { Component } from 'react';
import {RIM_OR_WELLS, ACCESORIES} from '../../../../../../constants/app/files'
import InfoAccesory from './info-accessory';
import GalleryCar from '../../../../../shared/gallery';
import { MESSAGES_WITHOUT_PICTURES } from '../../../../../../constants/app/vehicle';
import InspectionTransform from '../../../../../../lib/utils/transforms/inspections';
const Accessories = ({images = [], handleSelect=() => {}, picturesObserveds = [], inspection = {}}) => {
	const accessoriesImgs = images ? InspectionTransform.transformImages(images, ACCESORIES, 'accessoryCode') : [];
	const aux = [];
	return(
		<div className="row row-tab-container">
			<InfoAccesory accessories={images}/>
			<GalleryCar images={accessoriesImgs} title={MESSAGES_WITHOUT_PICTURES.type_01}  handleSelect={handleSelect('accessory')} picturesObserveds={picturesObserveds} allImages={images}  inspection={inspection}/>
		</div>
	);
}
export default Accessories;


// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/accessories/index.js